// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"441":"7c8603ff","668":"a7c5fc6c","722":"007faffb","758":"81688900"}[chunkId] + ".chunk.js";
};